<template>
  <nav class="navbar-wrapper" style="background-color: #24252a;">
    <div class="navbar-content-inner">

      <a href="#" class="d-flex align-items-center text-decoration-none nav-logo-pushed">
        <img :src="logoSecond" style="max-width: 200px; max-height: 70px; padding: 5px 0;" alt="Logo" />
      </a>

      <div id="navigation" class="collapse navbar-collapse w-100 py-lg-0"></div>

      <div class="right-actions-group">
        <div class="dropdown profile-group" v-if="clientName">
          <div class="profile-card">
            <div class="profile-image">
              <img :src="userImg" alt="Profile Picture" />
            </div>
            <div class="profile-info">
              <p class="name">{{ clientName }}</p>
            </div>
          </div>
        </div>

        <button class="menu-toggle-btn" @click="toggleMenu">
          <i class="fas fa-bars"></i>
        </button>
      </div>

    </div>
  </nav>

  <div :class="['menu-slide-overlay', { 'is-open': isMenuOpen }]" @click="toggleMenu">
    <div class="fullscreen-menu-content" @click.stop>
      <div class="menu-header">
        <p class="menu-title white-text">Menyu</p>
        <button class="close-menu-btn modern-close-btn" @click="toggleMenu">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <ul class="menu-list">
      </ul>

      <div class="menu-footer">
        <p class="logged-in-user">
          Müştəri: <strong>{{ clientName }}</strong>
        </p>
        <button class="signout-button" @click="SignOut">
          <i class="fa fa-sign-out-alt"></i> &nbsp; Etibarlı çıxış
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import logoSecond from "@/assets/img/logo.png";
import userImg from "@/assets/img/user.png";

export default {
  name: "Navbar",
  props: {
    clientName: {
      type: String,
      default: ""
    }
  },
  emits: ['print'],
  data() {
    return {
      logoSecond,
      userImg,
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? "hidden" : "";
      document.body.style.overflowX = this.isMenuOpen ? "hidden" : "";
    },
    closeMenuOnly() {
      this.isMenuOpen = false;
      document.body.style.overflow = "";
      document.body.style.overflowX = "";
    },
    async SignOut() {
      this.closeMenuOnly();
      try {
        await this.$store.dispatch("logout");
        localStorage.removeItem('report_token');
        this.$router.push("/session/LOGOUT");
      } catch (error) {
        console.error("Logout sırasında bir hata oluştu:", error);
        localStorage.removeItem('report_token');
        this.$router.push("/session/LOGOUT");
      }
    }
  }
};
</script>
<style scoped>
</style>
